import { Validation } from './Validation';
import { WeekDay } from "./WeekDay";

export default interface BusinessHoursJson {
   /**
    * Wochen Tag für den die Zeiten gelten.
    */
   weekDay: WeekDay;

   /**
     * Beginn der Öffnungszeit im Format hh:mm
     */
   beginTime: string;

   /**
     * Ende der Öffnungszeit im Format hh:mm
     */
   endTime: string;
}

export function defaultBusinessHoursJson(): BusinessHoursJson {
  return {
    weekDay: 1,
    beginTime: "",
    endTime: ""
  };
}

export function validateBusinessHoursJson(item: BusinessHoursJson) {
  return new Validation(item)
    .validateInteger("weekDay", 0, 6)
    .validateTime("beginTime")
    .validateTimeLaterTime("endTime", "beginTime")
    .finish();
}